import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "../../wrapper/Layout";
import ExternalLoginPage from "../../../page/ExternalLoginPage";
import IsTestingAppWrapper from "../../wrapper/IsTestingAppWrapper/IsTestingAppWrapper";
import ForgotPasswordPage from "../../../page/ForgotPasswordPage/ForgotPasswordPage";
import LinkPage from "../../../page/LinkPage/LinkPage";
import PersistLogin from "../../auth/PersistLogin";
import RequiredAuth from "../../auth/RequiredAuth";
import HomePage from "../../../page/HomePage/HomePage";




function Router() {
  return (
    <Routes>
      <Route element={<IsTestingAppWrapper />}>
        <Route element={<Layout />}>
          <Route path="/login/" element={<ExternalLoginPage />} />
          <Route path="/forgot_password/" element={<ForgotPasswordPage />} />
          <Route path="/link/:kind/:token/" element={<LinkPage />} />



          <Route element={<PersistLogin />}>
            <Route element={<RequiredAuth />}>
              <Route path="/" element={<HomePage />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Route>
      </Route>
    </Routes>
  );
}
export default Router;
